import React from "react";
import { useHistory } from "react-router-dom";

import {
  Context,
  notFoundPath,
  fetchLesson,
  fetchNotificationTeachingHintsIntroductionLessonId,
} from "../../../teacherStore";
import { parseQueryParams } from "../../../libs/Util";
import Guideline from "../../../templates/teacher/Guideline";

export default () => {
  const lessonParam = parseInt(parseQueryParams()["lesson"]);
  const { state, dispatch } = React.useContext(Context);
  const history = useHistory();
  const classListInParams = parseQueryParams()["classList"];
  const classList = React.useMemo(
    () =>
      classListInParams
        ? classListInParams.split(",").map((classID: string) => Number(classID))
        : null,
    [classListInParams],
  );

  if (!classListInParams) {
    history.push(notFoundPath);
    return null;
  }

  React.useEffect(() => {
    dispatch(fetchLesson(lessonParam));
  }, [dispatch, lessonParam, classList]);

  const lesson = React.useMemo(
    () =>
      state.lesson && state.lesson.id === lessonParam ? state.lesson : null,
    [lessonParam, state.lesson],
  );

  const handleChangeLesson = React.useCallback(
    lessonId => {
      history.push({
        search: `?lesson=${lessonId}&classList=${classList}`,
      });
    },
    [classList, history],
  );

  const syncNotificationHint = () => {
    if (state.notification_teaching_hint_introduction_lesson_id) {
      dispatch(fetchNotificationTeachingHintsIntroductionLessonId(classList));
    }
  };

  return (
    <Guideline
      lesson={lesson}
      classListString={classList}
      prevLessonId={state.prev_lesson_id}
      nextLessonId={state.next_lesson_id}
      onChangeLesson={handleChangeLesson}
      surveyEnabled={state.teacher_survey_enabled}
      isInitialShowChat={
        !!state.notification_teaching_hint_introduction_lesson_id
      }
      syncNotificationHint={syncNotificationHint}
    />
  );
};
